import WhatKindVideoMakeModalComponent from "./WhatKindVideoMakeModalComponent";

export default WhatKindVideoMakeModalComponent;